import type { MyProfileQuery } from '@/apollo/graphql';

type PrivilegeFlags = Partial<
  Pick<NonNullable<MyProfileQuery['me']>, 'isSuperuser' | 'isDeveloper'>
>;

// A developer holds the same rights as a superuser everywhere, so the UI must
// never branch on isSuperuser alone.
export const hasElevatedRights = (user?: PrivilegeFlags | null) =>
  Boolean(user?.isSuperuser || user?.isDeveloper);
